import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import styles from './Row.module.scss';
var propTypes = process.env.NODE_ENV !== "production" ? {
  /** Html tag or react component to render */
  as: PropTypes.elementType,

  /** Child node */
  children: PropTypes.node.isRequired,

  /** Classes to customize container */
  className: PropTypes.string
} : {};
var defaultProps = {
  className: '',
  as: 'div'
};

function Row(props) {
  var {
    as: Tag,
    className,
    children
  } = props,
      otherProps = _objectWithoutProperties(props, ["as", "className", "children"]);

  return React.createElement(Tag, _extends({
    className: "".concat(styles.row, " ").concat(className)
  }, otherProps), children);
}

Row.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
Row.defaultProps = defaultProps;
export default Row;